type InputValidationOptions = {
  emoji?: boolean;
  specialCharacters?: boolean;
};

/** Strip non-alphanumeric characters while preserving spaces. */
export const STRIP_NON_ALPHANUMERIC_WITH_SPACES = /[^a-zA-Z0-9\s]/g;

/** Strip non-digit characters. */
export const STRIP_NON_DIGITS = /\D/g;

export const filterAlphanumericWithSpaces = (value: string) =>
  value.replace(STRIP_NON_ALPHANUMERIC_WITH_SPACES, '');

export const filterDigits = (value: string) =>
  value.replace(STRIP_NON_DIGITS, '');

/**
 * Sanitize free-text input.
 *
 * @example
 * inputValidation(value)                              // block both
 * inputValidation(value, { emoji: true, specialCharacters: false })
 * inputValidation(value, { emoji: false, specialCharacters: true })
 */
export const inputValidation = (
  value: string,
  options: InputValidationOptions = {},
) => {
  const { emoji = true, specialCharacters = true } = options;
  let next = value;

  if (emoji) {
    next = next.replace(
      /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{200D}\u{20E3}]/gu,
      '',
    );
  }

  if (specialCharacters) {
    next = next.replace(/[^\w\s\-_.&()',]/g, '');
  }

  return next;
};


export const separateNumber = (num: number | string | null | undefined = 0): string => {
  if (num === null || num === undefined || num === '') return '0';

  const cleanStr = String(num).replace(/,/g, '').trim();
  if (!cleanStr) return '0';

  // Match optional prefix, numeric integer part, optional decimal part, and optional suffix
  const match = cleanStr.match(/^([^\d.-]*)([-+]?\d+)(?:\.(\d+))?(.*)$/);
  if (!match) return cleanStr;

  const [, prefix, integerPart, decimalPart, suffix] = match;
  const parsedInt = Number(integerPart);

  if (isNaN(parsedInt)) return cleanStr;

  const formattedInt = parsedInt.toLocaleString('en-IN');
  const formattedDec = decimalPart !== undefined ? `.${decimalPart}` : '';

  return `${prefix || ''}${formattedInt}${formattedDec}${suffix || ''}`;
};
